import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonIcon } from "../shared/buttonIcon";
import { ContactSection } from "../shared/contactSection";
import { HomeContentContainer } from "../shared/homeContentContainer";
import styles from "./styles.module.scss";
import { Link, useLocation } from "react-router-dom";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";

interface ContactLocationState {
  onCloseLink?: string;
}

export function ContactPage() {
  const location = useLocation<ContactLocationState>();
  const onCloseLink = location.state?.onCloseLink || "/";

  return (
    <HomeContentContainer classNameInner={styles.root}>
      <Link to={onCloseLink} className={styles.close_link}>
        <ButtonIcon primary title="Close">
          <FontAwesomeIcon icon={faXmark} fontSize={20} />
        </ButtonIcon>
      </Link>
      <main className={styles.main}>
        <ContactSection />
      </main>
    </HomeContentContainer>
  );
}
